import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { CacheService } from '../../shared/services/cache.service';


@Injectable()
export class ProductTypesService {
  private apiUrl = APP_SETTINGS.PaymentTransactionApiUrl;

  constructor(
    private executeService: ExecuteService,
    private cacheService: CacheService,
    private errorHandler: ErrorHandlerService) { }

  public Get(): Observable<string[]> {
    const url = `${this.apiUrl}/products`;

    return this.cacheService.get('getPaymentTransactionsProductTypes',
      this.executeService.ExecuteWithToken('get', url)
        .pipe(
          catchError(this.errorHandler.handleError<string[]>('ProductTypesService_Get', [], true))
        ));
  }
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/services/productTypes.service.ts